export interface GalleryItem {
  image: string;
  title: string;
  text: string;
  caption: string;
  alt: string;
}

export const galleryItems: GalleryItem[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/wgpTBHDgt1uBtevpjJxoc6/01-sesion-completa.webp',
    title: 'Tu sesión, organizada por minutos',
    text: 'Ejemplo de 90 minutos: objetivo, material, agrupaciones y orden de tareas. La agenda remite a las fichas desarrolladas dentro del tomo.',
    caption: 'Tomo 3 · Sesión S09 · Página 60',
    alt: 'Agenda real de la sesión Conectar la salida entre líneas, para 12 jugadores de campo'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/vGDnc7Mp8vTZSxtMMKUkJp/02-tecnica-y-correcciones.webp',
    title: 'Qué corregir y cómo hacerlo',
    text: 'Control con oposición: organización, reinicios, rotaciones y una corrección observable. Incluye ajustes para facilitar o aumentar la dificultad.',
    caption: 'Tomo 2 · Ficha C08 · Página 20',
    alt: 'Ficha Orientar o devolver, con esquema de tres jugadores y tabla de corrección'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/5PUBEb9miPxcChdMzBrsha/03-defensa-coordinada.webp',
    title: 'La defensa se entiende en el campo',
    text: 'Un 3 contra 3 para cerrar el centro y orientar hacia fuera, con puntuación, rotaciones y progresión.',
    caption: 'Tomo 3 · Ficha D04 · Página 25',
    alt: 'Diagrama y reglas de la tarea defensiva Cerrar dentro y orientar fuera'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/iUjqd39DThgjdFtevZT7Ut/04-fisico-con-balon.webp',
    title: 'Esfuerzo y recuperación, definidos',
    text: 'Una tarea de respuesta a una señal y conducción, con turnos, pausas y espacio de frenado. La ficha explica qué observar antes de aumentar la exigencia.',
    caption: 'Tomo 4 · Ficha V02 · Página 14',
    alt: 'Ficha Elegir puerta a señal, con diagrama y dosificación del trabajo'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/1T2XkBdZsNk7dkLnhs4ZrD/05-balon-parado.webp',
    title: 'Una jugada y una salida alternativa',
    text: 'Córner corto con tercer jugador: secuencia, alternativa si se cierra el pase y organización tras pérdida o recuperación.',
    caption: 'Tomo 5 · Ficha CO02 · Página 8',
    alt: 'Esquema de córner corto con pases numerados, atacantes y defensores'
  }
];
